<template>
  <!-- 模板保持不变 -->
  <div class="el-header" :class="{ 'is-sticky': sticky, 'is-hidden': hidden }">
    <div class="head-content">
      <img src="@/assets/icon/logo.png" class="logo" alt="" @click="goHome">
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="toggleSidebar">
        <i class="el-icon-menu"></i>
      </div>
      <!-- 桌面端导航 -->
      <div class="header-r desktop-nav">
        <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <template v-for="menuItem in menuListI18n">
            <!-- 一级标题无子菜单 -->
            <el-menu-item v-if="!menuItem.children" :key="menuItem.name" :index="menuItem.name" :class="{ 'en-text': $i18n.locale === 'en' }">
              <span slot="title">{{menuItem.name}}</span>
            </el-menu-item>
            <!-- 一级标题有子菜单 -->
            <el-submenu v-else :key="menuItem.name" :class="{ 'en-submenu': $i18n.locale === 'en' }">
              <span style="color: #fff !important;" :style="{ fontSize: $i18n.locale === 'en' ? '16px' : '18px' }" slot="title">{{menuItem.name}}</span>
              <!-- 二级标题 -->
              <el-menu-item v-for="(children, childId) in menuItem.children" :key="childId" :index="children.name">
                {{children.name}}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
        <!-- 语言切换按钮 -->
        <div class="lang-switch" @click="switchLanguage">
          <img src="@/assets/langs.png" alt="语言切换">
          <span>{{ $i18n.locale === 'zh' ? '中文' : 'EN' }}</span>
        </div>
      </div>
    </div>

    <!-- 侧边栏导航 -->
    <div class="sidebar" :class="{ 'sidebar-open': sidebarOpen }">
      <div class="sidebar-close" @click="toggleSidebar">
        <i class="el-icon-close"></i>
      </div>
      <div class="sidebar-menu">
        <div 
          v-for="menuItem in menuListI18n" 
          :key="menuItem.id" 
          class="sidebar-item"
          @click="handleSidebarSelect(menuItem.name)"
        >
          {{menuItem.name}}
        </div>
      </div>
      <div class="sidebar-footer">
        <div class="lang-options">
          <span 
            :class="{ 'active-lang': $i18n.locale === 'zh' }" 
            @click="setLangMobile"
          >
            简体
          </span>
          <span class="lang-divider">|</span>
          <span 
            :class="{ 'active-lang': $i18n.locale === 'en' }" 
            @click="setLangMobile"
          >
            English
          </span>
        </div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="sidebar-mask" v-if="sidebarOpen" @click="toggleSidebar"></div>
  </div>
</template>

<script>
export default {
  name: "myFooter",
  props: ["data"],
  data() {
    return {
      defaultActive: "",
      sticky: false, // 吸顶状态
      hidden: false, // 向下滚动时收起导航栏
      lastScrollY: 0,
      url:"https://www.11xyz.com/it_kc_index",
      menuList: [
        { id: '1', name: '快车科技', path: '/'},
        { id: '2', name: 'AI赋能', path: '/digitalEmpowerment'},
        { id: '3', name: '产业集群智能体', path: '/IndustrialAgent'},
        { id: '4', name: 'AI六脉神剑', path: '/liumaishenjian'},
        { id: '5', name: 'AI天龙八部', path: '/tianlongbabu'},
        { id: '7', name: '资质荣誉', path: '/qualification'},
        { id: '8', name: '寻找超人', path: '/hire'},
      ],
      sidebarOpen: false, // 侧边栏状态
    };
  },
  computed: {
    // 根据当前语言返回对应的菜单列表
    menuListI18n() {
      if (this.$i18n.locale === 'zh') {
        return this.menuList;
      } else {
        return [
          { id: '1', name: this.$t('header.kuaiche'), path: '/'},
          { id: '2', name: this.$t('header.ai'), path: '/digitalEmpowerment'},
          { id: '3', name: this.$t('header.clusterAgent'), path: '/IndustrialAgent'},
          { id: '4', name: this.$t('header.divine'), path: '/liumaishenjian'},
          { id: '5', name: this.$t('header.tianlongbabu'), path: '/tianlongbabu'},
          { id: '7', name: this.$t('header.qualification'), path: '/qualification'},
          { id: '8', name: this.$t('header.hire'), path: '/hire'},
        ];
      }
    }
  },
  created() {
    const savedLang = localStorage.getItem('lang');
    if (!savedLang) {
      this.$i18n.locale = 'zh';
      localStorage.setItem('lang', 'zh');
    } else {
      this.$i18n.locale = savedLang;
    }
    // 根据当前路由设置初始选中项
    this.updateActiveMenu();
  },
  mounted() {
    // 捕获阶段监听，兼容 body 作为滚动容器的情况
    window.addEventListener('scroll', this.handleScroll, true);
    // 初始化检查滚动位置
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    // 点击 logo 返回首页
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
        // 页面实际滚动容器是 body，需手动回到顶部
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    // 切换侧边栏显示状态
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
      // 当侧边栏打开时，禁止body滚动
      if (this.sidebarOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    // 侧边栏菜单选择
    handleSidebarSelect(key) {
      this.defaultActive = key;
      this.handleSelect(key);
      this.toggleSidebar(); 
    },
    updateActiveMenu() {
      // 根据当前路由路径判断应该选中哪个菜单项
      const currentPath = this.$route.path;
      // 查找匹配的菜单项
      const matchedMenu = this.menuListI18n.find(item => item.path === currentPath);
      const newActive = matchedMenu ? matchedMenu.name : "";
      // 避免不必要的状态抖动：仅在值变化时更新
      if (this.defaultActive !== newActive) {
        this.defaultActive = newActive;
      }
    },
    // 其他方法保持不变
    handleSelect(key) {
      // 立即更新当前选中项
      if (this.defaultActive !== key) this.defaultActive = key;
      // 直接通过菜单配置查找对应路径
      const menuItem = this.menuListI18n.find(item => item.name === key);
      if (menuItem && menuItem.path) {
        if (this.$route.path !== menuItem.path) {
          this.$router.push({ path: menuItem.path });
        }
      }
    },
    // 通过英文标题获取中文标题
    getZhTitleByEnTitle(enTitle) {
      const titleMap = {
        [this.$t('header.kuaiche')]: '快车科技',
        [this.$t('header.ai')]: 'AI赋能',
        [this.$t('header.city')]: '城市客厅',
        [this.$t('header.product')]: '产业文创',
        [this.$t('header.solution')]: '综合解决方案',
        [this.$t('header.hire')]: '寻找超人',
      };
      return titleMap[enTitle];
    },
    // 切换语言方法
    switchLanguage() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.setLanguage(newLang);
    },
    setLangMobile() {
      this.switchLanguage()
      this.toggleSidebar();
    },
    // 设置语言
    setLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.updateActiveMenu();
    },
    // 监听滚动，切换吸顶/收起状态
    handleScroll(e) {
      // 忽略页面内部滚动容器的滚动事件
      const target = e && e.target;
      if (target && target !== document && target !== document.documentElement && target !== document.body) {
        return;
      }
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.sticky = scrollY > 0;

      // 侧边栏打开时保持导航栏可见
      if (this.sidebarOpen) {
        this.hidden = false;
        this.lastScrollY = scrollY;
        return;
      }

      const delta = scrollY - this.lastScrollY;
      if (scrollY <= 60) {
        // 接近顶部时始终展开
        this.hidden = false;
      } else if (delta > 5) {
        // 向下滚动：收起
        this.hidden = true;
      } else if (delta < -5) {
        // 向上滚动：展开
        this.hidden = false;
      }
      this.lastScrollY = scrollY;
    },
  },
  watch: {
    $route() {
      this.updateActiveMenu();
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  width: 274px;
  cursor: pointer;
  transition: all 0.3s;
}

.el-menu-item {
  text-align: center;
  color: #fff !important;
  font-size: 18px;
  background: transparent !important;
  margin: 0 20px !important;
  padding: 0 0px !important;
}


@media (max-width: 1370px) { 
  
  .logo {
    width: 160px !important;
    cursor: pointer;
    transition: all 0.3s;
  }
   .el-menu-item {
      text-align: center;
      color: #fff !important;
      font-size: 16px;
      background: transparent !important;
      margin: 0 20px !important;
      padding: 0 0px !important;
    }
 }

.el-header {
  width: 100%;
  height: 100px;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.8);
  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s ease;

  &.is-sticky {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  &.is-hidden {
    transform: translateY(-100%);
  }

  .head-content {
    margin: 0 auto;
    min-width: 1150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 60px;
  }


  // 移动端菜单按钮
  .mobile-menu-btn {
    display: none;
    font-size: 24px;
    color: #fff;
    cursor: pointer;
  }

  .header-r {
    height: 100px;
    display: flex;
    align-items: center;
    
    .el-menu {
      width: 100%; 
      display: flex;
      justify-content: space-between; 
    }
    
    /* 语言切换按钮样式 */
    .lang-switch {
      width: 20%;
      display: flex;
      align-items: center;
      color: #fff;
      cursor: pointer;
      margin-left: 20px;
      white-space: nowrap;
      img {
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
      
      span {
        font-size: 16px;
      }
    }
    
    @media screen and (max-width: 1360px) {
      display: none;
    }
  }

  .el-menu {
    background: transparent !important;
    border-bottom: 0 solid #000 !important;

    // 英文模式下的菜单项样式
    .en-text {
      // margin: 0 10px !important;
      font-size: 16px !important;
      padding: 0 5px !important;
    }
    .en-submenu {
      margin: 0 10px !important;
      ::v-deep .el-submenu__title {
        padding: 0 5px !important;
      }
    }
  }

  /* 覆盖 Element UI 横向菜单项的默认下划线，让未激活项无下划线 */
  ::v-deep .el-menu--horizontal > .el-menu-item,
  ::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
    border-bottom: none !important;
  }

  /* 激活态时才显示下划线（更高优先级）*/
  ::v-deep .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #fffdfe !important;
  }

  /* 移除通用 .is-active 规则，避免影响到其它元素 */
  ::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
  }
  ::v-deep .el-submenu__title:hover{
    background: none!important;
  }
  ::v-deep .el-submenu__icon-arrow ,::v-deep .el-icon-arrow-down{
    color: #fff;
  }
  
  // 侧边栏样式
  .sidebar {
    position: fixed;
    top: 0;
    left: -100%;
    width: 300px;
    height: 100vh;
    background-color: #fff;
    z-index: 1000;
    transition: left 0.3s ease;
    overflow-y: auto;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);

    &.sidebar-open { left: 0; }
    
    .sidebar-close {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 24px;
      cursor: pointer;
      color: #333;
    }
    
    .sidebar-menu {
      padding: 60px 0 20px;
      margin-top: 8vh;
      
      .sidebar-item {
        padding: 20px 30px;
        font-size: 18px;
        color: #333;
        cursor: pointer;
      }
    }
    
    .sidebar-footer {
      padding: 20px 30px;
      margin: 20vh auto 0;
      
      .lang-options {
        display: flex;
        align-items: center;
        
        span {
          cursor: pointer;
          padding: 5px 10px;
          
          &.active-lang {
            color: #003C8C;
            font-weight: bold;
          }
        }
        
        .lang-divider {
          margin: 0 5px;
          cursor: default;
        }
      }
    }
  }
  
  // 遮罩层
  .sidebar-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}

@media screen and (max-width: 1360px) {
  .el-header{
    height: 50px;
    background: rgba(0, 0, 0, 0.8);

    .head-content{
      min-width: auto;
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;
    }
    .logo {
      width: 120px;
      margin: 0 auto;
      background-size: contain;
    }
    .mobile-menu-btn {
      display: block;
      position: static;
      order: -1;
    }
  }
  .desktop-nav {
    display: none;
  }
}
</style>